import { defineMessages } from 'react-intl';

export default defineMessages({
  suggestionsItemTitle: {
    id: 'global_page_not_found_suggestions_title',
    defaultMessage: '{%s} in',
  },
  defaultCarsPrefix: {
    id: 'global_coches',
    defaultMessage: 'Cars',
  },
  defaultProductsPrefix: {
    id: 'global_products',
    defaultMessage: 'Products',
  },
  defaultJobsPrefix: {
    id: 'global_empleo',
    defaultMessage: 'Jobs',
  },
});



// WEBPACK FOOTER //
// ./app/Suggestions/messages.js